import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { I18nFlagMsgKey } from './types';

const messages: Record<I18nFlagMsgKey, MessageDescriptor> = defineMessages({
	removedUserSuccessMsg: {
		id: 'users-and-roles.controllers.table-controller.removed-user-success-msg',
		defaultMessage: '{name} no longer has access to this project',
		description: 'Actor has been removed from the project and no longer has access to the project',
	},
	removedGroupSuccessMsg: {
		id: 'users-and-roles.controllers.table-controller.removed-group-success-msg',
		defaultMessage: 'Members of {name} can no longer access this project',
		description: 'Group has been removed from the project and no longer has access to the project',
	},
	removedUserSuccessMsgPermissionGated: {
		id: 'users-and-roles.controllers.table-controller.removed-user-success-msg-permission-gated',
		defaultMessage: 'Remove the user in site admin to remove project access',
		description:
			'Success dialog message when permission control is limited because it is Free version',
	},
	removedGroupSuccessMsgPermissionGated: {
		id: 'users-and-roles.controllers.table-controller.removed-group-success-msg-permission-gated',
		defaultMessage: 'Remove users in site admin to remove project access',
		description:
			'Success dialog message when permission control is limited because it is Free version',
	},
	genericSuccessTitle: {
		id: 'users-and-roles.controllers.table-controller.generic-success-title',
		defaultMessage: 'Success',
		description: 'Success title when some action succeeds',
	},
	genericErrorTitle: {
		id: 'users-and-roles.controllers.table-controller.generic-error-title',
		defaultMessage: 'Error',
		description: 'Error title when some action fails',
	},
	genericErrorMsg: {
		id: 'users-and-roles.controllers.table-controller.generic-error-msg',
		defaultMessage: 'Something went wrong. Try again.',
		description: 'Generic error message when some error occurred during user action',
	},
	lastAdminErrorMessage: {
		id: 'users-and-roles.controllers.table-controller.last-admin-error-message',
		defaultMessage:
			'This project needs at least one admin. Add another before changing your role or removing yourself.',
		description: 'Error message when you try removing the last admin from a project',
	},
});

export default messages;
